import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const STATISTICS_COUNT = "/api/getStatisticsCount",
	  STATISTICS_TREND = "/api/getStatisticsTrend"
	
	
export default {
	getStatisticsCount: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(STATISTICS_COUNT, params)
			commit('STATISTICS_COUNT', data);
		}catch(e){
			throw e
		}
	},
	getStatisticsTrend: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return http.get(STATISTICS_TREND, params)
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/home/actions.js